/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AiTriageConfig,
    AiTriageConfigFromJSON,
    AiTriageConfigFromJSONTyped,
    AiTriageConfigToJSON,
    AutoRebaseConfig,
    AutoRebaseConfigFromJSON,
    AutoRebaseConfigFromJSONTyped,
    AutoRebaseConfigToJSON,
    BaseConfig,
    BaseConfigFromJSON,
    BaseConfigFromJSONTyped,
    BaseConfigToJSON,
    FeedbackManagementConfig,
    FeedbackManagementConfigFromJSON,
    FeedbackManagementConfigFromJSONTyped,
    FeedbackManagementConfigToJSON,
    LockingConfig,
    LockingConfigFromJSON,
    LockingConfigFromJSONTyped,
    LockingConfigToJSON,
    RequiredChecksConfig,
    RequiredChecksConfigFromJSON,
    RequiredChecksConfigFromJSONTyped,
    RequiredChecksConfigToJSON,
    SponsorsLabelingConfig,
    SponsorsLabelingConfigFromJSON,
    SponsorsLabelingConfigFromJSONTyped,
    SponsorsLabelingConfigToJSON,
    TriageConfig,
    TriageConfigFromJSON,
    TriageConfigFromJSONTyped,
    TriageConfigToJSON,
} from './';

/**
 * 
 * @export
 * @interface PullRequestConfig
 */
export interface PullRequestConfig {
    /**
     * 
     * @type {AutoRebaseConfig}
     * @memberof PullRequestConfig
     */
    autoRebase?: AutoRebaseConfig;
    /**
     * 
     * @type {RequiredChecksConfig}
     * @memberof PullRequestConfig
     */
    requiredChecks?: RequiredChecksConfig;
    /**
     * 
     * @type {AiTriageConfig}
     * @memberof PullRequestConfig
     */
    aiTriage?: AiTriageConfig;
    /**
     * 
     * @type {TriageConfig}
     * @memberof PullRequestConfig
     */
    triage?: TriageConfig;
    /**
     * 
     * @type {LockingConfig}
     * @memberof PullRequestConfig
     */
    locking?: LockingConfig;
    /**
     * 
     * @type {FeedbackManagementConfig}
     * @memberof PullRequestConfig
     */
    feedbackManagement?: FeedbackManagementConfig;
    /**
     * 
     * @type {SponsorsLabelingConfig}
     * @memberof PullRequestConfig
     */
    sponsorsLabeling?: SponsorsLabelingConfig;
}

export function PullRequestConfigFromJSON(json: any): PullRequestConfig {
    return PullRequestConfigFromJSONTyped(json, false);
}

export function PullRequestConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): PullRequestConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'autoRebase': !exists(json, 'autoRebase') ? undefined : AutoRebaseConfigFromJSON(json['autoRebase']),
        'requiredChecks': !exists(json, 'requiredChecks') ? undefined : RequiredChecksConfigFromJSON(json['requiredChecks']),
        'aiTriage': !exists(json, 'aiTriage') ? undefined : AiTriageConfigFromJSON(json['aiTriage']),
        'triage': !exists(json, 'triage') ? undefined : TriageConfigFromJSON(json['triage']),
        'locking': !exists(json, 'locking') ? undefined : LockingConfigFromJSON(json['locking']),
        'feedbackManagement': !exists(json, 'feedbackManagement') ? undefined : FeedbackManagementConfigFromJSON(json['feedbackManagement']),
        'sponsorsLabeling': !exists(json, 'sponsorsLabeling') ? undefined : SponsorsLabelingConfigFromJSON(json['sponsorsLabeling']),
    };
}

export function PullRequestConfigToJSON(value?: PullRequestConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'autoRebase': AutoRebaseConfigToJSON(value.autoRebase),
        'requiredChecks': RequiredChecksConfigToJSON(value.requiredChecks),
        'aiTriage': AiTriageConfigToJSON(value.aiTriage),
        'triage': TriageConfigToJSON(value.triage),
        'locking': LockingConfigToJSON(value.locking),
        'feedbackManagement': FeedbackManagementConfigToJSON(value.feedbackManagement),
        'sponsorsLabeling': SponsorsLabelingConfigToJSON(value.sponsorsLabeling),
    };
}

